<template>
  <div>
    <div v-if="editable && !editing" class="flex justify-end mb-2">
      <SecondaryButton data-test="edit-cost-items" @click="startEditing">
        <PencilIcon class="h-4 w-4 mr-1.5" aria-hidden="true" />
        {{ t("edit_button") }}
      </SecondaryButton>
    </div>

    <div v-if="editing">
      <CostItems :initial-items="costs" @updated-items="onUpdatedItems" />
      <div class="mt-4 flex justify-end gap-2">
        <SecondaryButton :disabled="saving" data-test="cancel-cost-items" @click="cancelEditing">
          {{ t("cancel_button") }}
        </SecondaryButton>
        <GenericButton :disabled="saving" data-test="save-cost-items" @click="save">
          {{ t("save_button") }}
        </GenericButton>
      </div>
    </div>

    <Table v-else :columns="columns" :data="costs">
      <template #type="{ row }">
        {{ $t(`claim.cost_type.${row.type}`) }}
      </template>
    </Table>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { CostItems, GenericButton, SecondaryButton, Table } from "@estaly/ui";
import { PencilIcon } from "@heroicons/vue/outline";

export default {
  name: "ClaimCostItemsEditor",

  components: { CostItems, GenericButton, SecondaryButton, Table, PencilIcon },

  props: {
    costs: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["save", "update:editing"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      editedCosts: [],
    };
  },

  computed: {
    columns() {
      return [
        {
          label: "Type",
          field: "type",
          slot: "type",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Prix unitaire HT",
          field: "unitPriceBeforeTax",
          price: true,
        },
        {
          label: "Prix unitaire TTC",
          field: "unitPrice",
          price: true,
        },
        {
          label: "Quantité",
          field: "quantity",
          numeric: true,
        },
        {
          label: "Total",
          field: "total",
          price: true,
          bold: true,
        },
      ];
    },
  },

  methods: {
    startEditing() {
      this.editedCosts = this.costs.map((cost) => ({ ...cost }));
      this.$emit("update:editing", true);
    },

    cancelEditing() {
      this.editedCosts = [];
      this.$emit("update:editing", false);
    },

    onUpdatedItems(items) {
      this.editedCosts = items;
    },

    save() {
      this.$emit("save", this.editedCosts);
    },
  },
};
</script>

<i18n src="./ClaimCostItemsEditor.i18n.json"></i18n>
